import axios, { AxiosInstance } from 'axios';
import { v4 as random } from 'uuid';
import { merge, get, trimEnd } from 'lodash-es';

let instance: AxiosInstance;

export function getBaseUrl(): string {
  const url = trimEnd(process.env.REACT_APP_API_URL, '/');
  const isUrl = /^https?:\/\//.test(url);
  if (isUrl && process.env.NODE_ENV === 'production') {
    return url;
  }
  if (isUrl) {
    return window.location.origin + new URL(url).pathname;
  }
  return window.location.origin + url;
}

export function getInstance(): AxiosInstance {
  if (!instance) {
    const baseURL = getBaseUrl();
    instance = axios.create({ baseURL });
    instance.interceptors.request.use((config) => {
      return merge(config, {
        headers: {
          'X-B3-TraceId': random(),
        },
      });
    });
    instance.interceptors.response.use(undefined, (error) => {
      if (get(error, 'response.status') === 401) {
        window.location.href = `${baseURL}/audit`;
      }
      throw error;
    });
  }
  return instance;
}
